import React, {useEffect} from "react";
import {state} from "../../state";
import {chkDevice} from "../utils/Utils";
import FormatMaterialsData from "../data-format/FormatMaterialsData";
import FormatControlsData from "../data-format/FormatControlsData";

const DataLoader = () => {
  
  const formatData = (dataA, dataM) => {
  
    const appData = dataA;
    const matData = dataM;
    
    // titles, names
    state.appTitle = appData['appTitle'];
    
    // paths - models
    state.modelsFolderLocation = appData['modelsFolderLocation'];
    state.modelFileFormat = appData['modelFileFormat'];
    // paths - materials
    state.materialsLocation = 'https://' + matData['mainPath'] + matData['materialsLocation'];
    state.materialCategoryLocation = matData['materialCategoryLocation'];
    
    // format data
    FormatControlsData(appData.controls);
    FormatMaterialsData(matData["mainMaterialSets"]);
    
    // set ready
    state.userDevice = chkDevice();
    state.appReady = true;
    
  }
  
  useEffect(() => {

    // set appropriate urls for data
    // ('https://modeconfigurator.com/assets/Mode2/app-data/app-data.json')
    
    // from local public
    const dataUrls = ['./json/app-data.json', './json/material-data.json'];
    
    Promise.all(dataUrls.map(url => fetch(url)
      
      .then(r => r.json()))).then(([data1, data2]) => {
      
      formatData(data1, data2);
      
    }).catch(error => console.log('error - getting data', error))
    
    
  }, []);
  
};

export default DataLoader;
